import { ChangeDetectorRef, Component, DoCheck, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstantsService } from '../app-constants.service';
import { AppState } from '../app.service'
import { UtilityService } from '../common-services/utility.service';
import { DailyStepsService } from '../daily-steps/daily-steps.service';
import { Habit } from '../habit/habit.model';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { User } from '../user/user.model';
import { fadeInRightAnimation, fadeOutLeftAnimation, fadeOutRightAnimation, fadeOutUpAnimation, slideInLeftAnimation, slideInRightAnimation, slideInUpAnimation, slideOutDownAnimation, zoomInAnimation, slideInDownAnimation } from 'angular-animations';
import { SessionService } from '../session/session.service';
import { Platform } from '@ionic/angular';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { HomeUiService } from '../new-design/home-ui.service';
import { I18n } from '../i18n.service';
import * as _ from 'underscore';
import { YourPathComponent } from '../new-design/your-path/your-path.component';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import mixpanel from 'mixpanel-browser';
import { YourPathNewComponent } from '../new-design/your-path-new/your-path-new.component';
import { KyperDataApiService } from '../services/kyper-data-api.service';

@Component({
  selector: 'mobile-weldonescreen',
  templateUrl: './mobile-weldonescreen.component.html',
  styleUrls: ['./mobile-weldonescreen.component.scss'],
  animations: [
    fadeOutRightAnimation(),
    fadeOutLeftAnimation(),
    slideInUpAnimation(),
    fadeOutUpAnimation(),
    zoomInAnimation(),
    slideInRightAnimation({ duration: 1600 }),
    slideInLeftAnimation({duration:500}),
    slideInDownAnimation({ duration: 1000 }),
    fadeInRightAnimation({ duration:300 }),
  ]
})
export class MobileWeldonescreenComponent implements OnInit, DoCheck, OnDestroy {
  currentUser: User;
  currentPath: Path;
  currentDay: number;
  habit: Habit;
  stepScreensIds;
  postText:any = ''
  formRating1:any = 0
  scheduleDay: any;
  scheduledStep: any;
  dayHasContent: boolean;
  maxAllowedScheduleDay: any;
  activeDay: any;
  nextDay: any;
  titleOfTask: string;
  inoutScreen: any;
  isMobile: boolean;
  isMobileWebIos = false;
  isMobileWeb=false;
  allowScreenCount: boolean
  previousDayCompleted;
  public pathRegistration: any;
  currentScreenIndex = 0;
  currentStepActionPoints;
  currentClient;
   activeChapterIndex;
  stepIndex;
  @ViewChild('gifImage', { static: false }) gifImage: ElementRef;
    @ViewChild("textarea") txtarea: ElementRef;
  options: [
    {
      label: 'Fading Exits',
      animations: [
        'fadeOutLeft',
        'fadeOutRight',
        'fadeOutUp',
      ]
    },
    {
      label: 'Sliding Entrances',
      animations: ['slideInUp',]
    },
    {
      label: 'Zoom Entrances',
      animations: ['zoomIn', 'zoomInDown', 'zoomInLeft', 'zoomInRight', 'zoomInUp']
    },
  ]
  animationState = false;
  showDoors = true
  showBottomTextarea = false
  showInstruction = false
  @ViewChild('textAreaWrapper', { static: false }) textAreaWrapper: ElementRef;
  animationBoard = false;
  animateLabel = false
  showLabel = false
  animateStars = false
  showRatingBox = false
  starRating: string
  hideHorizontalLine = true
  @ViewChild('textAreaContainer', { static: false }) textAreaContainer: ElementRef;  
  dailyStepsArray;
  isIconDisliked: boolean = false;
  isIconLiked: boolean = false;
  mobileWeldoneScreenIds: string[] = [];
  isBadgesExpanded;
  unlockStepInoutScreenData;
  durationOfTask;
  unAttemptedActionPoints = {};
  totalUnAttemptedPoints = 0;
  state = false;
  reviewState = false;
  currentNumber =0
  @ViewChild("stepTitle") stepTitle: ElementRef;
  showStepTitle=true;
  isScreenVisited = false;
  streaksInfo;
  isStreaksScreenVisited = false;
  updatedStreaksWeeksData;
  showFirstDayInWeekStreakCompletedCount = false;
  showWeeklyStreakCompletedCount = false;
  currentOpenedChapter;
  currentOpenedStep;
  isLastStepInChapter: boolean = false;
  constructor(
    private appState: AppState, 
    public route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
    private homev5Service: HomeV5Service,
    private cdRef: ChangeDetectorRef,
    private toasterService: ToasterService,
    private dailyStepsService: DailyStepsService,
    private appConstantService: AppConstantsService,
    private utilService: UtilityService,
    private elementRef: ElementRef, 
    private routineService: RoutineService,
    private render: Renderer2,
    private i18n: I18n,
    private sessionService: SessionService,
    private keyboard: Keyboard,
    private platform: Platform,
    private kyperApiService: KyperDataApiService,
    public homeUIService: HomeUiService,) {
     
    this.currentUser = this.appState.get('currentUser');
    this.currentPath = this.appState.get('currentPath');
    this.isMobile = this.appState.get('isMobile')
     this.route.queryParamMap.subscribe(params => {
    const value = params.get('currentOpenedChapter');
       this.currentOpenedChapter = value ? +value : this.activeChapterIndex;
       this.currentOpenedStep = params.get('activeStepIndex') ? +params.get('activeStepIndex') : this.stepIndex;  
       this.currentDay = params.get('currentDay')?+params.get('currentDay'):this.appState.get('currentScheduleDay')
  });

    this.dailyStepsArray = this.appState.get('DailyStepsData')
    this.maxAllowedScheduleDay = this.appState.get('daysOfContent')
    this.scheduleDay = +this.currentDay
    this.pathRegistration = this.appState.get('pathRegistration')
    // if (this.currentDay < this.dailyStepsArray?.length) {
    //   this.habit = this.dailyStepsArray[this.currentDay].habits
    //   this.inoutScreen = this.dailyStepsArray[this.currentDay].inoutScreens
    // }
     this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.stepIndex = this.appState.get('reviewingStepIndex')
    if (this.currentDay < this.currentPath.lastDayOfContent() && this.dailyStepsArray[this.activeChapterIndex]?.steps?.length > this.stepIndex + 1) {
      this.inoutScreen = this.dailyStepsArray[this.activeChapterIndex]?.steps[this.stepIndex + 1]?.step
    }
    else if (this.currentPath.lastDayOfContent() > this.activeChapterIndex+1 && this.dailyStepsArray[this.activeChapterIndex+1]?.steps?.length > 0) {
      this.inoutScreen = this.dailyStepsArray[this.activeChapterIndex+1]?.steps[0]?.step
    }
     console.log("inoutScreenData", this.inoutScreen);
    // this.unlockStepInoutScreenData; = this.findFornextDay(this.currentPath.inoutScreens)
    if (this.appState.get('routine_schedule_day')) {
      this.currentDay = this.appState.get('routine_schedule_day')
      this.appState.set('routine_schedule_day', null)
    }
    // for(let i=this.currentDay + 1; i<= this.maxAllowedScheduleDay; i++) {
    //   this.dayHasContent = this.currentPath.checkContentForDay(i);
    //   if(this.dayHasContent) {
        this.nextDay = this.currentDay + 1;
        this.scheduleDay =this.currentDay + 1;
    //     break;
    //   }
    // }
    this.stepScreensIds = this.appState.get("stepScreenIds");
    this.scheduledStep = this.appState.get('scheduleDayForCurrentStep')  
    // this.currentStepActionInfo()
    //this.setDoorClosedAnimation()
   }

  ngDoCheck() {
    this.allowScreenCount = this.appState.get('allowScreenCount')
    this.dailyStepsArray = this.appState.get('DailyStepsData')
    if (this.mobileWeldoneScreenIds && this.mobileWeldoneScreenIds[this.currentScreenIndex]=='step-action-points-screen' && !this.isScreenVisited) {
      this.isScreenVisited = true;
      this.currentStepActionInfo();
      this.setDoorClosedAnimation();
      setTimeout(() => {
        //STOP confetti animation
        if (this.gifImage?.nativeElement) {
          this.gifImage?.nativeElement?.classList?.remove('bg_celebration')
        }
    },200);
    }
     if (this.mobileWeldoneScreenIds && this.mobileWeldoneScreenIds[this.currentScreenIndex]=='step-streaks-screen' && !this.isStreaksScreenVisited) {
      this.isStreaksScreenVisited = true;
      this.currentStepStreaksInfo()
    }
  }
  currentStepStreaksInfo() {
    this.updatedStreaksWeeksData = this.appState.get('updatedStreaksInfo');
    if (this.updatedStreaksWeeksData?.is_first_day_in_week_streak_completed && this.updatedStreaksWeeksData?.streak_dates?.length ==1) {
      this.showFirstDayInWeekStreakCompletedCount = true;
    }
    if (this.updatedStreaksWeeksData?.streak_dates?.length>=5) {
      this.showWeeklyStreakCompletedCount = true;
    }
    mixpanel.track('EOS streaks screen enabled', { streaksInfo: this.updatedStreaksWeeksData, isFirstDayInWeekStreakCompleted: this.showFirstDayInWeekStreakCompletedCount, isWeeklyStreakCompleted: this.showWeeklyStreakCompletedCount })
  }

  currentStepActionInfo() {
    let step_id = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.id
    this.homeUIService.getKyperStepwiseActionPoint(step_id).subscribe((res) => {
      this.currentStepActionPoints = res.data;
      //  document.documentElement.style.setProperty('--num', this.currentStepActionPoints?.total_action_points.toString());
      // let id = document.getElementsByClassName('number')
      // if (id) {
      //   id[0].setAttribute(
      //     "style",
      //     `content: counter(${this.currentStepActionPoints?.total_action_points});counter-reset: ${this.currentStepActionPoints?.total_action_points}`
      //   );
      // }
      if (this.currentStepActionPoints?.total > 0) {
        this.startCounterAnimation(this.currentStepActionPoints?.total)
      }      
      let poll, content, notification, profile, accountability, managerEmail, habit, action, assessment, reflection, question, nps;
      habit = this.stepScreensIds?.find((item) => item?.type === "routine");
      poll = this.stepScreensIds?.find((item) => item?.type === "poll");
      content = this.stepScreensIds?.find((item) => item?.type === "content");
      notification = this.stepScreensIds?.find((item) => item?.type === "notification");
      profile = this.stepScreensIds?.find((item) => item?.type === "profile");
      accountability = this.stepScreensIds?.find((item) => item?.type === "accountability");
      managerEmail = this.stepScreensIds?.find((item) => item?.type === "managerEmail");
      action = this.stepScreensIds?.find((item) => item?.type === "action");
      reflection = this.stepScreensIds?.find((item) => item?.type === "reflection");
      assessment = this.stepScreensIds?.find((item) => item?.type === "survey");
      question = this.stepScreensIds?.find((item) => item?.type === "question");
      nps = this.stepScreensIds?.find((item: any) => item?.type === "nps");
      if ((this.currentStepActionPoints?.details?.content == 0 || !this.currentStepActionPoints?.details?.content) && content) {
        this.totalUnAttemptedPoints += content.actionPoints;
        this.unAttemptedActionPoints['content'] = content.actionPoints;
      }
      if (habit) {
        this.totalUnAttemptedPoints += habit?.actionPoints;      
        this.unAttemptedActionPoints['habit'] = habit?.actionPoints;
      }
      if (poll) {
        if (this.currentStepActionPoints?.details?.poll == 0 || !this.currentStepActionPoints?.details?.poll) {
           this.totalUnAttemptedPoints += poll.actionPoints;
           this.unAttemptedActionPoints['poll'] = poll.actionPoints;
        }
        else if (this.currentStepActionPoints?.details?.poll > 0) {
          // let pointsDiff = poll.actionPoints - this.currentStepActionPoints?.details?.poll;
          // if (pointsDiff!=0) {
            this.totalUnAttemptedPoints += poll.actionPoints;
             this.unAttemptedActionPoints['poll'] = poll.actionPoints;
          // // }
          //   // else {
          //    this.totalUnAttemptedPoints += pointsDiff;
             //this.unAttemptedActionPoints['poll'] = pointsDiff;
          //}
         
        }
       
      }
      if ((this.currentStepActionPoints?.details?.notifications == 0 || !this.currentStepActionPoints?.details?.notifications) && notification) {
        this.totalUnAttemptedPoints += notification.actionPoints; 
        this.unAttemptedActionPoints['notifications'] = notification.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.profile == 0 || !this.currentStepActionPoints?.details?.profile) && profile) {
        this.totalUnAttemptedPoints += profile.actionPoints; 
        this.unAttemptedActionPoints["profile"] = profile.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.accountabilityEmail == 0 || !this.currentStepActionPoints?.details?.accountabilityEmail)&& accountability) {
        this.totalUnAttemptedPoints += accountability.actionPoints; 
        this.unAttemptedActionPoints['accountability'] = accountability.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.managerEmail == 0 || !this.currentStepActionPoints?.details?.managerEmail) && managerEmail) {
        this.totalUnAttemptedPoints += managerEmail.actionPoints; 
        this.unAttemptedActionPoints['managerEmail'] = managerEmail.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.action == 0 || !this.currentStepActionPoints?.details?.action)&& action) {
        this.totalUnAttemptedPoints += action.actionPoints; 
        this.unAttemptedActionPoints['action'] = action.actionPoints;
      }
      if ((this.currentStepActionPoints?.details?.assessment == 0 || !this.currentStepActionPoints?.details?.assessment) && assessment) {
      this.totalUnAttemptedPoints += assessment.actionPoints; 
      this.unAttemptedActionPoints['assessment'] = assessment.actionPoints;
    }
      if ((this.currentStepActionPoints?.details?.reflection == 0 || !this.currentStepActionPoints?.details?.reflection) && reflection) {
       this.totalUnAttemptedPoints += reflection.actionPoints; 
       this.unAttemptedActionPoints['reflection'] = reflection.actionPoints;
     }
      if ((this.currentStepActionPoints?.details?.socialDiscussion == 0 || !this.currentStepActionPoints?.details?.socialDiscussion) && question) {
       this.totalUnAttemptedPoints += question.actionPoints; 
       this.unAttemptedActionPoints['socialDiscussion'] = question.actionPoints;
     }
      if ((this.currentStepActionPoints?.details?.nps == 0 || !this.currentStepActionPoints?.details?.nps) && nps) {
        this.totalUnAttemptedPoints += nps.actionPoints;
        (this.unAttemptedActionPoints as any)['nps'] = nps.actionPoints;
      }
      const pathPersonalization: any = this.stepScreensIds?.find((item: any) => item?.type === 'pathPersonalization');
      if (!this.currentStepActionPoints?.details?.pathPersonalization && pathPersonalization?.actionPoints) {
        this.totalUnAttemptedPoints += pathPersonalization.actionPoints;
        (this.unAttemptedActionPoints as any)['pathPersonalization'] = pathPersonalization.actionPoints;
      }
    })
  }
  startCounterAnimation(targetNumber) {
    const element = document.querySelector('.number') as HTMLElement;
    if (element) {
      // element.style.setProperty('--num', targetNumber.toString());
      setTimeout(() => {
         this.animateCounter(0, targetNumber, 1000);
      }, 2150);     
    }
  }

  animateCounter(start: number, end: number, duration: number) {
    const stepTime = Math.abs(Math.floor(duration / (end - start)));
    let current = start;
    const step = () => {
      current += 1;
      this.currentNumber = current;
      if (current < end) {
        setTimeout(step, stepTime);
      }
    };
    step();
    console.log("this.currentNumber",this.currentNumber);
  }
  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.dailyStepsArray = this.appState.get('DailyStepsData')
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.stepIndex = this.appState.get('reviewingStepIndex')
    this.currentClient = this.appState.get('currentClient')
    this.streaksInfo = this.appState.get('dailyStreaksInfo');
    console.log("dailyStepsArray", this.dailyStepsArray,this.scheduledStep , this.currentDay, this.dailyStepsArray[this.currentDay]?.stepStatus);
    let isStepRestartedFromWeldone = this.appState.get("isCurrentStepRestarted")
    let isInitialWeldoneScreen =  this.appState.get('showInitialWeldone')
    // if ((this.scheduledStep == this.currentDay &&this.dailyStepsArray[this.currentDay]?.stepStatus==undefined )|| (this.scheduledStep == this.currentDay+1 && this.dailyStepsArray[this.currentDay]?.stepStatus==undefined )|| isStepRestartedFromWeldone ) {
    if (isStepRestartedFromWeldone || isInitialWeldoneScreen) {
      if (this.currentPath?.enabledAttributes?.action_hub && !(this.currentPath?.enabledAttributes?.action_hub == undefined)) {
        this.mobileWeldoneScreenIds = [
          'actionHubScreen',
          "step-action-points-screen",
          //  "step-badges-screen",
          "step-final-weldone-screen",
          //  "step-review-weldone-screen",
        ];
      }
      else {
        this.mobileWeldoneScreenIds = [
          "step-action-points-screen",
          //  "step-badges-screen",
          "step-final-weldone-screen",
          //  "step-review-weldone-screen",
        ];
      }
      if (this.appState.get('isStreaksInfoUpdated') || !this.streaksInfo?.todays_streak) {
        this.mobileWeldoneScreenIds.splice( this.mobileWeldoneScreenIds?.length-1,0,'step-streaks-screen')
      }
      let reviewedChapterIdx: number = -1;
      let reviewedStepIdx: number = -1;
      reviewedChapterIdx = this.currentOpenedChapter;
      reviewedStepIdx   = this.currentOpenedStep;
      const reviewedChSteps: any[] = this.dailyStepsArray?.[reviewedChapterIdx]?.steps ?? [];
      const isLastStepOfChapter = reviewedStepIdx >= 0 && (reviewedStepIdx + 1) >= reviewedChSteps.length;
      const hasNextChapter = (reviewedChapterIdx + 1) < (this.dailyStepsArray?.length ?? 0) &&
        (this.dailyStepsArray?.[reviewedChapterIdx + 1]?.steps?.length ?? 0) > 0;

      if (isLastStepOfChapter) {
        this.appState.set('completingChapterIndex', reviewedChapterIdx);
      }
      if (isLastStepOfChapter && hasNextChapter) {
        this.isLastStepInChapter = true;
        this.mobileWeldoneScreenIds.splice(this.mobileWeldoneScreenIds.length - 1, 0, 'step-chapter-complete-screen');
      }
      // Seen. Recorded the moment the first-time view is SHOWN, not on the way out: leaving can be a
      // page-level navigation or a refresh, neither of which runs ngOnDestroy, and the learner would
      // then be shown it again every time they reopened the step. The back arrow undoes this.
      this.markEndOfStepSeen()
      this.showingFirstVisitEndOfStep = true
      this.appState.set("showInitialWeldone", false);
      this.appState.set("isCurrentStepRestarted", false);
    console.log("this.mobileWeldoneScreenIds", this.mobileWeldoneScreenIds, this.mobileWeldoneScreenIds['action-points-screen']);
   }
    else {
      this.reviewState = true
      if (this.currentPath?.enabledAttributes?.action_hub && !(this.currentPath?.enabledAttributes?.action_hub == undefined)) {
        this.mobileWeldoneScreenIds = [
          'actionHubScreen',
          'step-review-weldone-screen'
        ]
      }
      else {
        this.mobileWeldoneScreenIds = [
          'step-review-weldone-screen'
        ]
      }
    }
    this.dailyStepsService.init()
    this.appState.set('allowNext', false)
    this.getActions(this.currentPath.id)
  }
  private capitalizeSentences(text: string): string {
    return text.replace(/(?:^|\.\s)([a-z])/g, (match) => match.toUpperCase());
  }
  capitalLine(event): void {
    console.log("test cap")
    let ele = document.getElementsByClassName("weldone-textMessage");
    if (event && event.target.value) {
      this.postText = this.capitalizeSentences(event.target.value);
    }
    const ta = event.target as HTMLTextAreaElement;
    ta.rows = 1;
    const style = getComputedStyle(ta);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.4;
    const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const rows = Math.ceil((ta.scrollHeight - padding) / lineHeight);
    ta.rows = Math.min(Math.max(rows, 1), 4);
    ta.style.overflowY = rows > 4 ? 'auto' : 'hidden';
  }
   getStepTitle(status) {
    if(status=='locked') {
      if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep+1]?.step?.title
      }
      else {
        return this.dailyStepsArray[this.currentOpenedChapter + 1]?.steps[0]?.step?.title
      }
    }
    else { 
    return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.title
    }
  }

  getLastStepPosition() {
    return this.dailyStepsArray[this.dailyStepsArray?.length-1]?.steps[this.dailyStepsArray[this.dailyStepsArray?.length-1]?.steps?.length-1]?.position
  }
  getStepImage(status) {
    if(status=='locked') {
      if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep+1]?.step?.image
      }
      else {
        return this.dailyStepsArray[this.currentOpenedChapter+1]?.steps[0]?.step?.image
      }
    }
    else {
     return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.image
    }
  }
    getStepDescription(status) {
    if(status=='locked') {
      if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep+1]?.step?.description
      }
      else {
        return this.dailyStepsArray[this.currentOpenedChapter+1]?.steps[0]?.step?.description
      }
    }
    else {
     return this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.description
    }
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  ngAfterViewInit(){
    setTimeout(() => {
      //STOP confetti animation
      if (this.gifImage?.nativeElement) {
        this.gifImage?.nativeElement?.classList?.remove('bg_celebration')
      }

      //Enable rating area with animation
      this.showRatingBox = true
      this.animateStars = false
      setTimeout(() => {
        this.animateStars = true
      }, 10);

      //Enable text area with animation

    }, 200);

  }
 
  goToHome() {
    this.appState.set('currentActiveStepIndex', this.appState.get('currentActiveStepIndex'));
    localStorage.setItem('stepCompleted',this.scheduledStep.toString())
    this.appState.set('isNewStep', undefined)
    this.appState.set('isHomeScreen', true)
    mixpanel.track("Clicked on home button at EOS")
    this.router.navigate(['/main'])
    this.appConstantService.removeAppStateData()
    if (this.allowScreenCount && this.currentDay ==this.scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.stepStatus!='Review'){
      this.utilService.setScreenCount()
    }   
  }

  findForCurrentDay(collection: any): any {
    return collection.find(
      item => item.startDay <= this.currentDay + 1 && this.currentDay + 1 <= item.endDay
    )
  }

  giveFeedback() {
    var step_rating = localStorage.getItem("step_score")
    var step_comment = localStorage.getItem("step_comment")
    try {
      const requestData = {
        'user_id': this.currentUser.id,
        'path_id': this.currentPath.id,
        'step_score': step_rating,
        'step_comment': step_comment,
        'step_id': this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.step?.id,
        'step_version_id': this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep]?.stepVersion?.id
      }
      if (requestData.step_comment === "" && requestData.step_score === "0") {
        this.toasterService.warning(this.i18n.t('Please enter a comment'))
        return
      } else {
        this.homev5Service.postStepFeedback(requestData).subscribe(
          (response) => {
            // this.toasterService.success(this.i18n.t('Thank you for your feedback!'))
            this.postText = ''
            this.animateStaticInfo()
            this.cdRef.detectChanges()
          },
          (error) => {
            this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }
        )       
      }

    } catch (o_O) {
      console.log(o_O);
    }

  }

  findCurrentPlatform(){
    const ua = navigator.userAgent.toLowerCase();
    const hasTouch = navigator.maxTouchPoints > 1 || 'ontouchstart' in window;

    // Actual tablets (Android Tablets, iPads)
    const isTablet = /ipad|android(?!.*mobi)|tablet/i.test(ua);

    // Exclude touch laptops (Windows/macOS laptops with touchscreens)
    const isLaptop = hasTouch && !isTablet && /windows|mac os|linux/i.test(ua);
    if(this.platform.is("mobileweb") && this.platform.is("ipad") && (!isLaptop || !this.platform.is('desktop'))){
      return 'web-ipad';
    } else if(this.platform.is("mobileweb") && this.platform.is("tablet") && (!isLaptop || !this.platform.is('desktop'))){
      return 'web-tablet';
    } else if(this.platform.is("mobileweb") && this.platform.is("ios") && !this.platform.is("ipad")){
      return 'web-ios';
    } else if(this.platform.is("mobileweb") && this.platform.is("android") && !this.platform.is("tablet")){
      return 'web-android';
    } else if(this.platform.is("ios") && this.platform.is("mobile")){
      return 'ios';
    } else if(this.platform.is("android") && this.platform.is("mobile")){
      return 'android';
    } else if(!this.isMobile){
      return 'web';
    }
  }

  /**
   * Marks a step whose end-of-step the learner has actually been THROUGH.
   *
   * Written when the first-time view is shown, and removed again only by the back arrow — so going
   * back from the action points and returning is still the first-time experience, while closing,
   * navigating away or refreshing all count as having seen it.
   */
  /** The learner has now seen this step's first-time end-of-step. */
  markEndOfStepSeen() {
    try { localStorage.setItem(this.endOfStepSeenKey(this.currentDay), 'yes') } catch (e) { /* storage unavailable */ }
  }

  /** Undo it: the back arrow returns to the step, so the end-of-step is unseen again. */
  clearEndOfStepSeen() {
    try { localStorage.removeItem(this.endOfStepSeenKey(this.currentDay)) } catch (e) { /* storage unavailable */ }
  }

  /**
   * Is the view on screen the FIRST-VISIT end-of-step, as opposed to a review of a finished step?
   * Set where that view is built, which is also where the step is marked seen.
   */
  showingFirstVisitEndOfStep = false;

  endOfStepSeenKey(step: number): string {
    return `Toggle:User:${this.currentUser?.id}:EOSSeen:${this.currentPath?.id}:${step}`
  }

  isDayLocked(nextDay){
    localStorage.setItem('stepCompleted',this.scheduledStep.toString())
    // if (this.allowScreenCount && this.currentDay ==this.scheduledStep && this.dailyStepsArray[this.scheduledStep-1]!='Review'){
    //   this.utilService.setScreenCount()
    // }
    this.appState.set('isHomeScreen',true)
    var currentDay = nextDay - 1
     let stepStatus;
    if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
        this.appState.set('reviewingStepIndex', this.currentOpenedStep + 1)
        stepStatus = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep + 1]?.stepStatus
      }
      else {
      this.appState.set('reviewingStepIndex', 0)
      this.appState.set('currentActiveChapter', this.currentOpenedChapter + 1)
      stepStatus = this.dailyStepsArray[this.currentOpenedChapter + 1]?.steps[0]?.stepStatus
      }
    this.appState.set('selectedLevelIds', undefined)
    let levelSaveData = this.appState.get('levelSaveData')
    if (levelSaveData) {
      localStorage.setItem(
        `Toggle:Day:${levelSaveData.currentDay}:LevelNumber:${levelSaveData.levelId}:true`,
        'true'
      )
      this.appState.set('showUpdatedScreens', undefined)
      this.appState.set('levelSaveData', undefined)
    }

    if (nextDay >= this.scheduledStep && this.scheduledStep <= this.maxAllowedScheduleDay && (stepStatus==undefined || stepStatus==null)) {
      localStorage.setItem("isBeginClicked", "true");
       mixpanel.track("Clicked on Next button at EOS to unlock next step",{currentDay:currentDay, unlockingStepDay: nextDay})
       this.appState.set('currentActiveStepIndex', this.appState.get('reviewingStepIndex'))
      this.unlockReplay(currentDay)
      
    } else {
       mixpanel.track("Reviewing the next completed step from EOS",{currentDay:currentDay, unlockingStepDay: nextDay})
      this.replay(nextDay)
    }
  }


  replay(i) {
    let updateScheduleDay=i;
    // Deliberately writes no step indexes here. `currentActiveChapter` means the learner's ACTIVE
    // chapter (home-ui owns it); leaving a reviewed step's chapter in it made the home screen open
    // the active step on the wrong chapter. Both step components resolve their own indexes from the
    // step position instead.
    this.appState.set('maxAllowedScheduleDay', updateScheduleDay);
    this.appState.set('currentScheduleDay', updateScheduleDay);
    // this.appState.set('scheduleDayForCurrentStep', updateScheduleDay);
    this.scheduledStep = this.appState.get('scheduleDayForCurrentStep');
      localStorage.removeItem(
        `Toggle:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${!(i == undefined) ? i : this.scheduleDay
        }`
      );
      this.router.navigate([
        '/content',
        !(i == undefined) ? i : this.scheduledStep,
      ])
    // this.router.navigate([
    //   '/content',
    //   !(i == undefined) ? i : this.scheduleDay,
    // ])
    return false
  }

  unlockReplay(i) {
    if (i <= 0) {
      return
    }
    let dailyStepsArray = this.appState.get('DailyStepsData');
     let stepIndex = this.appState.get('reviewingStepIndex');
    let activeChapterIndex = this.appState.get('currentActiveChapter');
    //commenting 668 frontend change
    let stepData = dailyStepsArray[activeChapterIndex]?.steps[stepIndex]
    const reqData = {
      user_id: this.currentUser.id,
      path_id: this.currentPath.id,
      step: stepData?.position,
      step_id: stepData?.step?.id,
      platform: this.findCurrentPlatform(),
      original_step:stepData?.originalStep
    };
    
    this.routineService.startTime(reqData).subscribe( (response) => {
      console.log('post request succesful', response);
       mixpanel.track(` New step ${this.currentDay +1} is started from EOS`)
    }, (error) => {
      console.log('Error: ', error);
      this.toasterService.warning(this.i18n.t("Error, please check!"));
    });

    let updateScheduleDay = i + 1
    let data = {
      'schedule_day': updateScheduleDay,
      'user_id': this.currentUser.id
    }

    // for(let s=i; s>=0; s--) {
    //   this.dayHasContent = this.currentPath.checkContentForDay(s);
    //   if (this.dayHasContent) {
    //     this.previousDayCompleted = !!this.homev5Service.checkPrevDayCompleted(
    //       this.pathRegistration,
    //       s,
    //       this.currentUser,
    //       this.currentPath
    //     )
    //     break;
    //   }
    // }
    
    // let stepsArray = this.homev5Service.removeDuplicates(this.pathRegistration.screensViewed, "step");
    // stepsArray.forEach(element => {
    //   if(element.step === this.scheduleDay && element.totalScreens === element.visitedScreens){
    //     this.previousDayCompleted = true
    //   }
    // });
  
    // if (this.previousDayCompleted) {

      this.homev5Service.updateScheduleDay(data).subscribe(
        (response) => {
          if (response.success == true) {
            mixpanel.track('Schedule day was updated during unlocking at EOS', {data:response, updatedScheduleDay:updateScheduleDay})
            this.appState.set('allowScreenCount', true)
            this.appState.set('isNewStepUnlocked', true)
            this.appState.set('maxAllowedScheduleDay', updateScheduleDay)
            this.appState.set('currentScheduleDay', updateScheduleDay)
            this.appState.set('scheduleDayForCurrentStep', updateScheduleDay)
            this.appState.set('indexOfLevel', 0)
            this.appState.set('levelUpdated', undefined)
            // this.maxAllowedScheduleDay = this.appState.get(
            //   'maxAllowedScheduleDay'
            // ) // LUMBA-1379
            this.scheduleDay = this.appState.get('currentScheduleDay') // LUMBA-1379
            this.scheduledStep = this.appState.get('scheduleDayForCurrentStep')

            this.appState.set('LevelNumber',1)

            localStorage.removeItem(
              `Toggle:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${
                !(i == undefined) ? i + 1 : this.scheduledStep
              }`
            )
            // this.spinnerService.on()
            this.router.navigate([
              '/content',
              !(i == undefined) ? i + 1 : this.scheduledStep,
            ])
            return false

          } else {
            this.toasterService.warning(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }

        },
        (error) => {
          this.toasterService.warning(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          console.log('Response of update  error', error)
        }
      )
    // } else {
    //   this.toasterService.warning(this.i18n.t('Please complete previous step'))
    // }
  }


  // getTodaysTask(){
  //   if(this.inoutScreen){
  //     this.titleOfTask = this.inoutScreen.homepageSubtext.text;
  //     return this.titleOfTask;
  //     }
  // }

  changeStyle(){
    document.getElementById('stepDiv').classList.add('unlocked_screen');
  }

  getActions(pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getActionsList(requestData).subscribe((response) => {
      this.appState.set('todoActions',response.actions)
    }, (error) => {
      console.log('error :', error);
    })
    this.kyperApiService.getHabits(pathId);

  }

  setDoorClosedAnimation(){
    //Doors opening animation
    this.animationState = false;
    setTimeout(() => {
      this.animationState = true;
    }, 0);
    setTimeout(() => {
      this.showDoors = false;
    }, 1000);
    setTimeout(() => {
      this. showStepTitle = false;
    }, 1300);
  }

  onTextAreaClick(){
    this.showInstruction = true
    this.hideHorizontalLine = false
    // setTimeout(() => {
    //   this.textAreaWrapper.nativeElement.classList.add('textArea-wrapper-onClick')
    // }, 10);
    this.enableHeight(this.textAreaContainer, this.isMobile, this.platform, this.keyboard)
  }

  post(){
    this.showInstruction = false
    this.hideHorizontalLine = true
    localStorage.setItem('step_comment',this.postText);
    this.giveFeedback()
    this.showBottomTextarea = false;
  }

  setStars(formRating1){
    this.starRating = this.sessionService.returnStarsAsString(formRating1)
    localStorage.setItem('step_score',JSON.stringify(this.formRating1));
  }

  animateStaticInfo(){
    setTimeout(() => {
      this.showLabel = true
    }, 50);
    this.animateLabel = true;
    setTimeout(() => {
      this.animateLabel = false;
    }, 1000);
    setTimeout(() => {
      this.showLabel = false
    }, 1000);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.textAreaWrapper?.nativeElement.contains(event.target)) {
      console.log('clicked inside');
    } else {
      this.showInstruction = false
      this.hideHorizontalLine = true
      // this.onBackgroundTap();
      // setTimeout(() => {
      //   this.textAreaWrapper?.nativeElement.classList.remove('textArea-wrapper-onClick')
      // }, 10);
    }
  }

  enableHeight(textareaContainer, isMobile, platform, keyboard){
    //this code is for increasing the height of the text area for android device when keyboard pops up
    if(isMobile){
      if (platform.is("android") || platform.is("ios")) {
        //  this.textareaContainer.nativeElement?.setAttribute('style', 'margin-bottom:200px;')
        let id = document.getElementsByClassName("wrap-next-btn");
        let id2= document.getElementsByClassName('weldone-action-scroll')
        let id3= document.getElementsByClassName('bottom-textarea')
        keyboard.onKeyboardDidShow().subscribe((info) => {
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          console.log("keyboard will show with height", info.keyboardHeight);
          // textareaContainer.nativeElement.style.setProperty(
          //   'bottom',
          //   `0px`
          // );
          if(platform.is("android")&& id3 ){
            // id3[0].setAttribute('style',`bottom: calc(${info.keyboardHeight}px + 34px)!important`) 
            id3[0].setAttribute('style',`bottom: 0!important`) 
          }
          if(platform.is("ios")&& id3 ){
            // id3[0].setAttribute('style','bottom: calc(100vh - 550px)!important') 
            id3[0].setAttribute('style','bottom: ' + info.keyboardHeight + 'px!important')  
          }
          // if (id) {
          //   id[0].setAttribute('style','position:relative;width: calc(100% - 40px)')
          // }
          // if (id2) {
          //   id2[0].setAttribute('style','overflow-y:hidden;height:calc(100vh - 74px); padding-bottom: 185px;')
          // }
          // textareaContainer.nativeElement.style.setProperty(
          //   "position",
          //   "relative"
          // );
        });

        keyboard.onKeyboardDidHide().subscribe((info) => {
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
          console.log("keyboard did hide", info.keyboardHeight);
          console.log("keyboard did hide", info);
          // textareaContainer.nativeElement.style.setProperty(
          //   'margin-bottom',
          //   `${0}px`
          // );
          // textareaContainer.nativeElement.style.setProperty(
          //   'bottom',
          //   `${75}px`
          // );
          // textareaContainer.nativeElement.style.setProperty(
          //   "position",
          //   "fixed"
          // );
          // if (id) {
          //   id[0].setAttribute("style", "position:fixed; bottom: 0.5%;width: calc(100% - 70px)");
          // }
          // if (id2) {
          //   id2[0].setAttribute('style','overflow-y:auto;height:calc(100vh - 74px); padding-bottom: 185px;')
          // }
          if(platform.is("android")&& id3 ){
            id3[0].setAttribute('style','bottom:0!important') 
          }
        });
      }
      // else if (platform.is('android')) {

      // }
    }
  }

   dislike(val) {
    if (!val) {
        setTimeout(() => {
          this.isIconDisliked = true;
          this.isIconLiked = null;
        }, 100);
    }
  }

  like(val) {
    if (val) {
       setTimeout(() => {
         this.isIconLiked = true;
         this.isIconDisliked = null;
       }, 100);
    }
  }

  nextStepEndScreen() {
    this.currentScreenIndex++;
    this.rightSwipeAnimation();
  }
  rightSwipeAnimation() {
    this.state = false;
    setTimeout(() => {
      this.state = true;
    }, 1);
  }
  
  preventKeyboardDismiss(event: TouchEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName !== 'TEXTAREA' && target.tagName !== 'BUTTON') {
      event.preventDefault();
    }
  }

  onBackgroundTap() {
    if (this.showBottomTextarea && !this.showInstruction) {
      setTimeout(() => {
        this.showBottomTextarea = false;
      }, 100);
    }
  }
  showTextArea() {
   setTimeout(() => {
     this.showBottomTextarea = true;
   }, 190);   
    console.log("show textarea called", this.showBottomTextarea)
  this.animationBoard = false;
  setTimeout(() => {
    this.animationBoard = true;
    this.txtarea?.nativeElement?.focus();
    this.txtarea.nativeElement.autofocus=true
  }, 200);  

      this.enableHeight(this.textAreaContainer, this.isMobile, this.platform, this.keyboard)  
  }

  expandBadges(val) {
    this.isBadgesExpanded = val;
  }
  changeFont() {
  
    const element = this.stepTitle?.nativeElement;
    const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2');
    if(specificElement) {
      this.render.setStyle(specificElement, 'font-size', '20px');
      this.render.setStyle(specificElement, 'font-weight', '400');
      this.render.setStyle(specificElement, 'margin-bottom', '0px');
      this.render.setStyle(specificElement, 'font-style', 'normal');
      this.render.setStyle(specificElement, 'line-height', 'normal');
      this.render.setStyle(specificElement, 'font-family', 'Roboto');
     this.render.setStyle(specificElement, 'word-break', 'break-word');
     this.render.setStyle(specificElement, 'overflow', 'hidden');
     this.render.setStyle(specificElement, ' text-overflow', 'ellipsis');
     this.render.setStyle(specificElement, 'display', '-webkit-box');
     this.render.setStyle(specificElement, '-webkit-line-clamp', '2');
     this.render.setStyle(specificElement, '-webkit-box-orient', 'vertical');

    }
  return true;
  }
  getTaskDurations() {
       if (this.currentDay < this.currentPath.lastDayOfContent() && this.dailyStepsArray[this.currentOpenedChapter]?.steps?.length > this.currentOpenedStep + 1) {
      this.inoutScreen = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.currentOpenedStep + 1]?.step
    }
    else if (this.currentPath.lastDayOfContent() > this.currentOpenedChapter+1 && this.dailyStepsArray[this.currentOpenedChapter+1]?.steps?.length > 0) {
      this.inoutScreen = this.dailyStepsArray[this.currentOpenedChapter +1]?.steps[0]?.step
    }
    if (this.inoutScreen && !_.isUndefined(this.inoutScreen)) {
      if (this.inoutScreen?.stime && this.inoutScreen?.etime) {
        this.durationOfTask =
          this.inoutScreen.stime + " - " + this.inoutScreen.etime;
        return this.durationOfTask;
      } else if (!this.inoutScreen?.stime && this.inoutScreen?.etime) {
        this.durationOfTask = this.inoutScreen.etime;
        return this.durationOfTask;
      } else {
        return "5 - 10";
      }
    } else {
      return "5 - 10";
    }
    }
  openYourPaths() {
    this.router.navigate(["/main"]);
    let isChaptersEnabled = this.currentPath?.kyperChapters?.length>0 && this.currentPath['enabledAttributes']?.chapters ==true
    setTimeout(() => {
      this.homeUIService.openNextComponent(isChaptersEnabled?YourPathNewComponent:YourPathComponent);
    }, 300);
  }
  restartStep(val,day) {
    this.appState.set("isCurrentStepRestarted", val)
     this.appState.set('currentScheduleDay', day);
    if(day==this.currentDay){
      this.appState.set('reviewingStepIndex', this.currentOpenedStep)
      this.router.navigate(['/content', day], { queryParams: {currentOpenedChapter: this.currentOpenedChapter, currentOpenedStep:this.currentOpenedStep } })
    }
    else 
    {
      let chapterInfo = this.currentPath.findChapterAndStepIndex(this.dailyStepsArray, day);
      this.appState.set('reviewingStepIndex', chapterInfo?.stepIndex)
      this.router.navigate(['/content', day], { queryParams: {currentOpenedChapter: chapterInfo?.chapterIndex, currentOpenedStep: chapterInfo?.stepIndex } })
    }
  }
  moveToLastScreen() {
    // The back arrow: the learner is returning to the step rather than finishing with the end-of-step,
    // so it must still be unseen when they come back to it.
    // Only the first-visit view can be un-seen. Reviewing a finished step never marked anything,
    // so clearing here would wipe the marker left from when the step was genuinely completed — and
    // the next Next would then replay the first-visit flow for an already-finished step.
    if (this.showingFirstVisitEndOfStep) { this.clearEndOfStepSeen(); }
    let screenIds = this.appState.get('currentStepScreenIds')
    this.appState.set('reviewingStepIndex', this.currentOpenedStep)
      this.appState.set('currentScheduleDay', this.currentDay);
    this.router.navigate(['/content', this.currentDay], { queryParams: { startFromScreen: screenIds[screenIds?.length-1], currentOpenedChapter: this.currentOpenedChapter,currentOpenedStep: this.currentOpenedStep } })
  }
  @HostListener('touchend', ['$event'])
    onTouchEnd(event: TouchEvent) {
      this.addInputEventListeners();
  }
  addInputEventListeners() {
    const inputs = document.querySelector("textarea");
     let id = document.getElementsByClassName("wrap-next-btn");
    let id2 = document.getElementsByClassName("weldone-action-scroll");
    if (inputs) {
          this.render.listen(inputs, "focus", () => {
      // if (id) {
      //       id[0].setAttribute('style','position:relative;width: calc(100% - 40px)')
      //     }
          // if (id2) {
          //   id2[0].setAttribute('style','overflow-y:auto;height:calc(100vh - 74px); padding-bottom: 60px;')
          // }
    });
    }

  }
   removeInputEventListeners() {
    const inputs = document.querySelector("textarea");
    if (inputs) {
       this.render.listen(inputs, "focus", null);
    }
   
  }
  ngOnDestroy(): void {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    this.appState.set("stepScreenIds", null);
    if (!this.appState.get("isCurrentStepRestarted")) {
      this.appState.set('isStreaksInfoUpdated', false)
      this.appState.set('updatedStreaksInfo', null);
    }
    // this.appState.set("isCurrentStepRestarted", false);
    this.appState.set('currentStepScreenIds', null)
    this.removeInputEventListeners();
  }
}
